import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "utils/api";

// estimation quotation
export const createLumberCalculation = createAsyncThunk(
  'lumber-save',
  async ({ value, bodyParams }, thunkAPI) => {
    try {
      const response = await API.put(`/estimationquotation/${value}`, bodyParams);
      return response
    }
    catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  })
